"use strict";

import angular from "angular";

import template from "./companies-import-preview.component.html";
import "./companies-import-preview.component.scss";

import _ from "lodash";
import { CompanyContact } from "../../../entity/CompanyContact";
import { CompanyEntity } from "../../../entity/CompanyEntity";
import { Company } from "../../../gateway/Company/Company";
import { CompanyContactHttpGateway } from "../../../gateway/CompanyContact/CompanyContactHttpGateway";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import { ConsultCompanyCnpjUsecase } from "../../../usecases";
import { GetCompaniesByFilterUsecase } from "../../../usecases/get-companies-by-filter.usecase";

class CompaniesImportPreviewComponent {
    Events = new Events();
    companies = [];
    contacts = [];
    companiesFake = new Array(6);
    formTable = {};
    blockToast = false;
    companiesSelected = [];
    hasSortedOnLoad = false;
    categories = [
        { label: "A", value: "A" },
        { label: "B", value: "B" },
        { label: "C", value: "C" },
        { label: "D", value: "D" }
    ];
    segmentGroups = [
        { label: "Comércio", value: "Comércio" },
        { label: "Indústria", value: "Indústria" },
        { label: "Serviço", value: "Serviço" },
        { label: "Outros", value: "Outros" }
    ];
    taxations = [
        { label: "Simples Nacional", value: "Simples Nacional" },
        { label: "Lucro Real", value: "Lucro Real" },
        { label: "Lucro Presumido", value: "Lucro Presumido" },
        { label: "MEI", value: "MEI" },
        { label: "Pessoa Física", value: "Pessoa Física" },
        { label: "Outros", value: "Outros" }
    ];
    hasChanges = false;
    documentsRegistereds = [];
    loadingDocument = false;
    constructor($stateParams, $scope, toast) {
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.toast = toast;
    }

    $onInit() {
        this.loading = true;
        this.$scope.$on("CompaniesImportPreviewRegenarateContacts", () => {
            this.generateContacts();
        });
        this.generateContacts();
        this.setDocumentRegistereds();
    }

    forceTouched() {
        if (this.$stateParams.from === null) return;
        angular.forEach(this.formTable, function (field) {
            if (field && field.$setTouched) {
                field.$setTouched();
            }
        });
        this.$scope.$applyAsync();
    }

    $onChanges(changes) {
        if (
            changes.triggerGetCompanies &&
            !changes.triggerGetCompanies.isFirstChange()
        ) {
            this.handleGetCompanies({ companies: this.companies });
        }
        if (changes.companies && !changes.companies.isFirstChange()) {
            console.log("companies changed", changes.companies);
            this.generateContacts();
            this.setDocumentRegistereds();
            this.openToastLicenses();
        }
    }

    async setDocumentRegistereds() {
        if (!this.companies?.length) return;
        const documents = this.companies.map((c) => c.props.document);
        const getCompaniesByFilterUsecase = new GetCompaniesByFilterUsecase();
        const companies = await getCompaniesByFilterUsecase.execute({
            accountingId: this.accountingData._id,
            filter: {
                documents,
                status: ["ATIVO", "INATIVO"]
            },
            options: {
                entity: true
            }
        });
        if (companies?.length) {
            this.documentsRegistereds = companies.map((c) => c.props.document);
        }
        for (const company of this.companies) {
            this.setCompanyDuplicateDocument(company);
        }
        this.$scope.$applyAsync();
    }

    async generateContacts() {
        if (!this.companies?.length) return;
        this.skeleton = true;
        this.loading = true;
        const contacts = [];
        let companiesContacts = [];
        if (this.companies?.length)
            companiesContacts = await this.getCompaniesContacts();
        for (let index = 0; index < this.companies.length; index++) {
            const company = this.companies[index];
            const companyContacts = companiesContacts.find(
                (c) => c.props._id === company.props._id
            );
            let companyContact = {};
            if (companyContacts?.props?.contacts?.length) {
                const contact = this.contactsEmails.find(
                    (c) => c.companyId === company.props._id
                );
                companyContact = companyContacts.props.contacts.find(
                    (cc) => cc.props.email === contact?.email
                );
            }
            if (companyContact?.props?._id) contacts.push(companyContact);
            else {
                const contact = {
                    name: "",
                    email: "",
                    whatsapp: "",
                    relations: {
                        nps: { status: false },
                        user: { status: false }
                    },
                    type: "company",
                    accountingId: this.accountingData._id,
                    companyId: company.props._id
                };
                const contactEntity = CompanyContact.restore(contact);
                contacts.push(contactEntity);
            }
        }
        this.contacts = contacts;
        this.loading = false;
        this.skeleton = false;
        this.$scope.$applyAsync();
        setTimeout(() => {
            this.forceTouched();
            setTimeout(() => {
                this.sortCompanies();
                this.$scope.$applyAsync();
            }, 300);
        }, 300);
    }

    onAddCompany() {
        const company = {
            name: "",
            document: "",
            status: "INATIVO",
            category: "",
            segmentGroup: "",
            taxation: ""
        };
        const companyEntity = CompanyEntity.restore(company);
        this.companies.push(companyEntity);
        const contact = {
            name: "",
            email: "",
            whatsapp: "",
            relations: {
                nps: { status: false },
                user: { status: false }
            },
            type: "company",
            accountingId: this.accountingData._id,
            companyId: ""
        };
        const contactEntity = CompanyContact.restore(contact);
        this.contacts.push(contactEntity);
    }

    async getCompaniesContacts() {
        const companyGateway = new Company();
        const response = await companyGateway.getGroupByContacts({
            accountingId: this.accountingData._id,
            type: "company",
            userId: new UserDataAdapter().user()?._id,
            options: { limit: 999 }
        });
        return response?.list || [];
    }

    activeCompanies() {
        const companiesToUpdate = [];
        const licensesAvailable = this.getLicensesAvailable();
        if (this.companies.length === licensesAvailable) {
            for (const company of this.companies) {
                company.props.status = "ATIVO";
            }
            companiesToUpdate.push(...this.companies);
        } else if (licensesAvailable < this.companies.length) {
            const companiesOrderedByTaxationSimples = _.orderBy(
                this.companies,
                (c) => (c.props.taxation === "Simples Nacional" ? -1 : 1)
            );
            for (let index = 0; index < licensesAvailable; index++) {
                const company = companiesOrderedByTaxationSimples?.[index];
                if (company) {
                    const companyIndex = this.companies.findIndex(
                        (c) => c.props._id === company.props._id
                    );
                    if (companyIndex > -1) {
                        this.companies[companyIndex].props.status = "ATIVO";
                        companiesToUpdate.push(this.companies[companyIndex]);
                    }
                }
            }
        } else if (licensesAvailable > this.companies.length) {
            for (let index = 0; index < licensesAvailable; index++) {
                const company = this.companies?.[index];
                if (company) {
                    company.props.status = "ATIVO";
                    companiesToUpdate.push(company);
                }
            }
        }
        if (this.onChangeCompanyStatus) {
            this.onChangeCompanyStatus({ companies: companiesToUpdate });
        }
    }

    onUpdateCategory(company, category) {
        this.hasChanges = true;
        company.props.category = category.value;
    }

    onUpdateSegmentGroup(company, segmentGroup) {
        this.hasChanges = true;
        company.props.segmentGroup = segmentGroup.value;
    }

    onUpdateTaxation(company, taxation) {
        this.hasChanges = true;
        company.props.taxation = taxation.value;
    }

    setCompanyDuplicateDocument(company) {
        if (
            company.props.document?.length === 11 ||
            company.props.document?.length === 14
        ) {
            const duplicated = this.hasDuplicateDocument(
                company.props.document
            );
            if (duplicated) company.documentDuplicated = true;
            else company.documentDuplicated = false;
        } else {
            company.documentDuplicated = false;
        }
    }

    async onChangeDocument(company, $index) {
        if (
            company.props.document?.length === 11 ||
            company.props.document?.length === 14
        ) {
            if (company.props.document?.length === 14)
                this.setDataByDocument(company, $index);
            const duplicated = await this.hasDuplicateDocumentCloud(
                company.props.document
            );
            if (duplicated) company.documentDuplicated = true;
            else company.documentDuplicated = false;
        } else {
            company.documentDuplicated = false;
        }
        this.$scope.$applyAsync();
    }

    async setDataByDocument(company, $index) {
        this.loadingDocument = true;
        const dataByCnpj = await this.consultCnpj(company.props.document);
        if (dataByCnpj?.isConsulted) {
            company.props.name = dataByCnpj.name;
            if (dataByCnpj?.partners?.length) {
                this.contacts[$index].props.name = dataByCnpj.partners[0].name;
            }
        }
        this.loadingDocument = false;
        this.$scope.$applyAsync();
    }

    async consultCnpj(cnpj) {
        const consultCompanyCnpjUsecase = new ConsultCompanyCnpjUsecase();
        const response = await consultCompanyCnpjUsecase.execute({ cnpj });
        return response;
    }

    async hasDuplicateDocumentCloud(document) {
        const getCompaniesByFilterUsecase = new GetCompaniesByFilterUsecase();
        const companies = await getCompaniesByFilterUsecase.execute({
            accountingId: this.accountingData._id,
            filter: {
                documents: [document],
                status: ["ATIVO", "INATIVO"]
            }
        });
        if (companies?.length >= 2) {
            return true;
        } else {
            return false;
        }
    }

    hasDuplicateDocument(document) {
        const documents = this.documentsRegistereds.filter(
            (d) => d === document
        );
        if (documents?.length >= 2) {
            return true;
        } else {
            return false;
        }
    }

    onChangeAny() {
        this.hasChanges = true;
    }

    getCompaniesActive() {
        const companiesSelected = this.companies.filter(
            (c) => c.props.status === "ATIVO"
        );
        return companiesSelected?.length || 0;
    }

    getTotalCompanies() {
        const companiesSelected = this.companies.filter(
            (c) => c.props.status === "ATIVO"
        );
        return (
            (this.accountingData?.analytics?.companiesCount || 0) +
            (companiesSelected?.length || 0)
        );
    }

    onToggleCompaniesStatus() {
        this.hasChanges = true;
        if (this.companies.every((c) => c.props.status === "ATIVO")) {
            this.companies.forEach((c) => (c.props.status = "INATIVO"));
        } else {
            this.companies.forEach((c) => (c.props.status = "ATIVO"));
        }
        this.openToastLicenses();
        this.$scope.$applyAsync();
    }

    allCompaniesIsActive() {
        return this.companies.every((c) => c.props.status === "ATIVO");
    }

    excededLicenses() {
        const licenses = this.getTotalCompanies();
        if (licenses > this.accountingData.plan.countCompany) return true;
        return false;
    }

    getLicensesAvailable() {
        const companiesSelected = this.companies.filter(
            (c) => c.props.status === "ATIVO"
        );

        const licensesAvailable =
            this.accountingData.plan?.countCompany -
            (this.accountingData.analytics?.companiesCount || 0);
        if (companiesSelected.length > licensesAvailable) return 0;
        return licensesAvailable - companiesSelected.length;
    }

    onChangeCheckboxStatus(company, index) {
        this.blockToast = true;
        if (company.props.status === "ATIVO") {
            company.props.status = "INATIVO";
        } else {
            company.props.status = "ATIVO";
        }
        if (company.props.status === "INATIVO")
            this.contacts[index].props.relations.user.status = false;
        this.toast.hide();
        if (this.onChangeCompanyStatus) {
            const companies = [company];
            this.onChangeCompanyStatus({ companies, index });
        }
    }

    openToastLicenses() {
        if (this.blockToast) return;
        if (this.from === "manualTable") return;
        const companiesToActive = this.getCompaniesToActive();
        if (companiesToActive == 0) return this.toast.hide();
        const options = {
            message: `Você possui ${this.getLicensesAvailable()} licenças disponíveis.`,
            buttons: {
                primary: {
                    label: `Ativar ${companiesToActive} empresas`,
                    action: () => {
                        this.Events.send(
                            "jornada.empresasimportadas.toast.ativarlicensas"
                        );
                        this.activeCompanies();
                        this.toast.hide();
                    }
                }
            },
            after: {
                then: (result) => {},
                catch: (error) => {}
            }
        };
        this.toast.snackbar(options);
    }

    getCompaniesToActive() {
        const companiesInactive = this.companies.filter(
            (c) => c.props.status === "INATIVO"
        );
        const licensesAvailable = this.getLicensesAvailable();
        if (companiesInactive?.length > licensesAvailable) {
            return licensesAvailable;
        } else {
            return companiesInactive?.length;
        }
    }

    onToggleAccess(company, contact, path, index) {
        if (path === "user.status") {
            const hasValidName =
                contact.props.name && contact.props.name.trim();
            const hasValidEmail =
                this.formTable[`contactEmail${index}`]?.$valid &&
                contact.props.email;
            if (!hasValidName || !hasValidEmail) return;
        }
        if (
            path === "user.status" &&
            company.props.status === "INATIVO" &&
            !contact.props.relations.user.status
        ) {
            this.blockToast = true;
            company.props.status = "ATIVO";
            this.toast.hide();
            if (this.onChangeCompanyStatus) {
                this.onChangeCompanyStatus({ companies: [company], index });
            }
        }
        if (this.isAccessDisabled(company, path)) return false;
        contact.toggleRelationStatus(path);
    }

    isAccessDisabled(company, accessPath) {
        return false;
    }

    isCheckedAccess(contact, path) {
        return _.get(contact, `props.relations.${path}`);
    }

    onRemoveCompany(index) {
        this.companies.splice(index, 1);
        this.contacts.splice(index, 1);
    }

    async onRemoveCompanySpreadsheet(index) {
        const company = this.companies[index];
        const contact = this.contacts[index];
        if (company?.props?._id) {
            const companyGateway = new Company();
            companyGateway.removeMany({
                companyIds: [company.props._id]
            });
        }
        if (contact?.props?._id) {
            const companyContactGateway = new CompanyContactHttpGateway();
            companyContactGateway.removeById({
                accountingId: this.accountingData._id,
                type: "company",
                _ids: [contact.props._id]
            });
        }
        this.companies.splice(index, 1);
        this.contacts.splice(index, 1);
        this.$scope.$applyAsync();
    }

    isCompanyInvalid(index) {
        if (!this.formTable) return false;
        const documentField = this.formTable[`document${index}`];
        const nameField = this.formTable[`name${index}`];
        const contactNameField = this.formTable[`contactName${index}`];
        const contactEmailField = this.formTable[`contactEmail${index}`];
        const contactWhatsappField = this.formTable[`contactWhatsapp${index}`];
        if (documentField && documentField.$invalid) return true;
        if (nameField && nameField.$invalid) return true;
        if (contactNameField && contactNameField.$invalid) return true;
        if (contactEmailField && contactEmailField.$invalid) return true;
        if (contactWhatsappField && contactWhatsappField.$invalid) return true;

        return false;
    }

    sortCompanies() {
        if (!this.companies?.length) return;
        const companiesWithIndex = this.companies.map((company, index) => ({
            company,
            contact: this.contacts[index],
            index,
            isInvalid: this.isCompanyInvalid(index),
            name: (company.props?.name || "").toLowerCase()
        }));
        const sorted = _.orderBy(
            companiesWithIndex,
            [(item) => !item.isInvalid, (item) => item.name],
            ["asc", "asc"]
        );
        this.companies = sorted.map((item) => item.company);
        this.contacts = sorted.map((item) => item.contact);
    }
}

CompaniesImportPreviewComponent.$inject = ["$stateParams", "$scope", "toast"];

export { CompaniesImportPreviewComponent };

const name = "companiesImportPreviewComponent";
const def = {
    bindings: {
        accountingData: "<",
        companies: "=",
        contactsEmails: "<",
        contacts: "=",
        formTable: "=",
        skeleton: "=",
        hasChanges: "=",
        saved: "<",
        loading: "<",
        saving: "<",
        canceling: "<",
        from: "@",
        onChangeCompanyStatus: "&",
        triggerGetCompanies: "<",
        handleGetCompanies: "&"
    },
    controller: CompaniesImportPreviewComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
